import Icon from '../components/Icon.vue'

Icon.register({
  'basketball-ball': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M212.3 10.3c-1.5 50-17 95.4-44.8 131.2l-77.4-77.4c36-29.7 78.4-47.5 122.2-53.8zM248 222l-46.3-46.3c37.2-45.4 57.5-103.8 58.7-167.7 51.9 2.6 103.1 21.1 145.5 56.1zM56.1 98.1l77.4 77.4c-35.7 27.8-81.2 43.3-131.2 44.8 6.3-43.8 24.1-86.2 53.8-122.2zM328.3 302.3l-46.3-46.3 157.9-157.9c35 42.4 53.5 93.6 56.1 145.5-64 1.3-122.4 21.6-167.7 58.7zM248 290l46.3 46.3c-37.1 45.3-57.4 103.7-58.7 167.7-51.9-2.6-103.1-21.2-145.5-56.1zM439.9 413.9l-77.4-77.4c35.7-27.7 81.1-43.2 131.2-44.8-6.3 43.8-24.1 86.2-53.8 122.2zM167.7 209.7l46.3 46.3-157.9 157.9c-35-42.4-53.5-93.6-56.1-145.5 63.9-1.1 122.3-21.5 167.7-58.7zM283.7 501.7c1.6-50 17.1-95.5 44.8-131.2l77.4 77.4c-36 29.7-78.4 47.5-122.2 53.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/basketball-ball.js
// module id = 650
// module chunks = 0